"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromResponseFormat = void 0;
exports.fromResponseFormat = (customerId, contracts) => {
    return Object.keys(contracts).map((terms) => ({
        terms_id: terms,
        agreed: contracts[terms].agreed,
        customer: customerId,
        signed: contracts[terms].signed
    }));
};
//# sourceMappingURL=helpers.js.map